const platform = {
    title: 'Configuración de la plataforma',
    subtitle: 'Gestiona administradores entre inquilinos y la apariencia global.',
    branding_title: 'Marca de la plataforma',
    branding_description: 'Se aplica a la consola, autenticación, centro de cuentas, demos y centro de ayuda.',
    product_name: 'Nombre del producto',
    slogan: 'Eslogan',
    light_logo: 'Logo de tema claro',
    dark_logo: 'Logo de tema oscuro',
    upload_logo: 'Subir logo',
    uploading: 'Subiendo…',
    logo_uploaded: 'Logo subido',
    hide_open_source_notice: 'Ocultar aviso de código abierto',
    hide_open_source_notice_description: 'Oculta enlaces de atribución visibles y conserva los archivos de licencia y código fuente.',
    save: 'Guardar cambios',
    saving: 'Guardando…',
    saved: 'Marca de la plataforma guardada',
    administrators_title: 'Administradores de la plataforma',
    administrators_description: 'Pueden gestionar todos los inquilinos y ajustes de la instancia.',
    administrator_identifier_placeholder: 'ID, nombre de usuario o correo',
    add_administrator: 'Añadir administrador',
    administrator_added: 'Administrador añadido',
    remove_administrator: 'Quitar administrador',
};
export default Object.freeze(platform);
